document.addEventListener('DOMContentLoaded', () => {
    function showDefaultContent() {
        const resultsContainer = document.getElementById('search-modal-results');
        if (!resultsContainer) return;

        const hasPredictiveResults = resultsContainer.querySelector('#predictive-search-results');

        if (hasPredictiveResults) {
            const recentSearchesSection = document.getElementById('recent-searches-section');
            if (recentSearchesSection) recentSearchesSection.classList.add('hidden');
            const recentlyViewedSection = document.getElementById('recently-viewed-products-section');
            if (recentlyViewedSection) recentlyViewedSection.classList.add('hidden');
            return;
        }

        const renderRecentSearches = window.searchRecentSearches?.renderRecentSearches;
        const renderRecentlyViewedProducts = window.searchRecentlyViewed?.renderRecentlyViewedProducts;

        if (renderRecentSearches && renderRecentlyViewedProducts) {
            Promise.all([
                renderRecentSearches(),
                renderRecentlyViewedProducts()
            ]).catch(e => {
                console.error('Error loading default content:', e);
            });
        }
    }

    window.searchHistory = {
        trackSearch: window.searchRecentSearches?.trackSearch || (() => { }),
        showDefaultContent,
        renderRecentSearches: window.searchRecentSearches?.renderRecentSearches || (() => { }),
        renderRecentlyViewedProducts: window.searchRecentlyViewed?.renderRecentlyViewedProducts || (() => { })
    };
});
